<script setup lang="ts">
  import { Modal } from 'bootstrap'
  import { ref, onMounted } from 'vue'

  const modal = ref<InstanceType<typeof Modal> | null>(null)

  onMounted(() => {
    modal.value = new Modal('#modal-wrong-credentials-sis-ar', {
      backdrop: 'static',
      keyboard: false,
    })
  })

  function show() {
    modal.value?.show()
  }

  function hide() {
    modal.value?.hide()
  }

  defineExpose({ show, hide })
</script>

<template>
  <div
    id="modal-wrong-credentials-sis-ar"
    class="modal modal-md fade"
    tabindex="-1"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header pb-3">
          <h5 class="modal-title">Usuário ou senha inválidos</h5>

          <button class="btn-close" @click="hide" />
        </div>

        <div class="modal-body py-3">
          <img alt="modo de isolamento" src="../assets/isolation-mode.svg" />
          <div class="mt-5">
            <p class="fs-6 text-start">
              <strong
                >Ops! Parece que os dados inseridos não estão corretos.</strong
              >
            </p>
            <p class="fs-6 text-start pt-3">
              Por favor, verifique seu usuário e senha de emissão e tente
              novamente.
            </p>
          </div>
        </div>

        <div class="modal-footer py-3">
          <button
            class="btn btn-primary"
            type="button"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            Tentar novamente
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
  .modal-title {
    color: var(--bs-danger);
  }

  .accordion-button {
    background: var(--bs-grayscale-light);
  }

  @media (min-width: 576px) {
    .modal-md {
      --bs-modal-width: 440px;
    }
  }
</style>
